import styled from 'styled-components'
import Grid from '@material-ui/core/Grid'
import TypographyPro from 'themes/TypographyPro'
import { getTranslatedTextByKey, getUserLanguage, isMobileApp } from 'utils/utils'

const TermsPrivacyAgreeStyledGrid = styled(Grid)`
	margin-top: 12px;
`

const TermsPrivacyAgreeStyledTypographyPro = styled(TypographyPro)`
	color: var(--footerAndDarkBackgrounds);
	text-align: start;

	a {
		margin: 0;
		line-height: 20px;
		text-decoration: underline;
		color: var(--footerAndDarkBackgrounds);
		${({ theme }) => theme.BodyRegularClickable};
	}
`

const ReCaptchaV3PrivacyNotice = () => {

	const languageQueryParam = `?hl=${getUserLanguage()}`

	const googlePrivacyUrl = `https://policies.google.com/privacy${languageQueryParam}`
	const googleTermsUrl = `https://policies.google.com/terms${languageQueryParam}`

	return (
		<TermsPrivacyAgreeStyledGrid container direction="row">
			<TermsPrivacyAgreeStyledTypographyPro variant="BodyRegular">
				<p className="recaptcha-notice">
					{getTranslatedTextByKey('eCommerce.reCaptchaV3.privacyNoticePrefix', 'This site is protected by reCAPTCHA and the Google')}{' '}
					<a href={googlePrivacyUrl} target={isMobileApp() ? '_self' : 'privacy'}>
						{getTranslatedTextByKey('eCommerce.reCaptchaV3.privacyLinkName', 'Privacy Policy')}
					</a>{' '}
					{getTranslatedTextByKey('and', 'and')}{' '}
					<a href={googleTermsUrl} target={isMobileApp() ? '_self' : 'terms'}>
						{getTranslatedTextByKey('eCommerce.reCaptchaV3.termsLinkName', 'Terms of Service')}
					</a>{' '}{getTranslatedTextByKey('eCommerce.reCaptchaV3.privacyNoticeSuffix', 'apply.')}
				</p>
			</TermsPrivacyAgreeStyledTypographyPro>
		</TermsPrivacyAgreeStyledGrid>
	)
}

export default ReCaptchaV3PrivacyNotice
